var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 2.66675H7.99992C7.29267 2.66675 6.6144 2.9477 6.1143 3.4478C5.6142 3.94789 5.33325 4.62617 5.33325 5.33341V26.6667C5.33325 27.374 5.6142 28.0523 6.1143 28.5524C6.6144 29.0525 7.29267 29.3334 7.99992 29.3334H23.9999C24.7072 29.3334 25.3854 29.0525 25.8855 28.5524C26.3856 28.0523 26.6666 27.374 26.6666 26.6667V12.0001L17.3333 2.66675Z",
    stroke: "#374151",
    strokeWidth: 2.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 2.66675V12.0001H26.6666",
    stroke: "#374151",
    strokeWidth: 2.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.2dfb4d0bb0d629bdfe5cd7cc61fe1e83.svg";
export { ForwardRef as ReactComponent };